/* eslint-disable no-sequences */
import React from 'react';

import Return from '../../../images/return.png';
import { Autocomplete } from '@material-ui/lab';
import { TextField, Chip } from '@material-ui/core';
import { FaRegBell } from 'react-icons/fa';
import templates from '../../../images/temas';
import { BaSeButton, BaSeIcon, BaSeTag } from '@base/react';
import { AddCarrosselModel } from './addCarrossel.model';
import { mapValueMsg } from './mapValuesPage';
import { formatDefaultValueSelect } from '../../../utils/mask';
import { formatDateToBR } from '../../../utils/time';
import styles from './styles.module.scss';

export const DEFAULT_VALUE_SELECIONE = 'Selecione';
export const DEFAULT_VALUE_ALL = 'Todos';

export const AddCarrossel = (props) => {
  const { onClose, selectedRow, allValuesOptions, typeScreen } = props;

  const {
    carrossel,
    setCarrossel,
    isLoadingCidades,
    cidades,

    newCPF,
    setNewCPF,
    isCPF,
    setIsCPF,
    planilha,
    setPlanilha,
    updateValue,
    removeCPF,
    updatePlanilha,
    recoveredByid,
    adicionarCarrossel,
    onChangeUF,
    cnaes,
    setCnaes,
    tipoServico,
    isLoading,
  } = AddCarrosselModel({ selectedRow, typeScreen, allValuesOptions, onClose });

  const backList = () => {
    onClose();
  };

  return (
    <div>
      <div className={styles.container_principal}>
        <div
          className={styles.filtro_container}
          style={{ backgroundColor: '#33CC99', height: '50px' }}
        >
          <div className={styles.modal_flex_direction_row}>
            <div style={{ display: 'flex' }}>
              <FaRegBell size={40} color="#ffffff" />
              <h2 className={styles.text_color_branco_titulo}>Carrosséis</h2>
            </div>
            <div>
              <div className={styles.icons_acoes_modal_filtro}>
                <img
                  onClick={backList}
                  alt="imagem"
                  className={styles.writin}
                  src={Return}
                />
                <p className={styles.text_color_branco}>Voltar</p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className={styles.div_tabelas_carrossel_filtro}>
            <div className={styles.separator_carrossel}>
              <h3>{mapValueMsg[typeScreen]}</h3>
            </div>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.container_itens}>
                <p>
                  <p className={styles.text_campos_cadastro}>
                    Título do Carrossel{' '}
                    <span className={styles.mandatory_carrossel}>*</span>
                  </p>
                </p>
                <input
                  value={carrossel.titulo ?? ''}
                  id={styles.input_nome}
                  onChange={(evento) => {
                    const newValue = evento.target.value;
                    if (newValue.length < 141)
                      updateValue('titulo', evento.target.value);
                  }}
                  placeholder="Digite aqui o título"
                />
                <div className={styles.sublabel_wrapper}>
                  <p className={styles.sublabel}>
                    {carrossel.titulo?.length ?? 0}/140
                  </p>
                </div>
              </div>

              <div className={styles.container_itens}>
                <p className={styles.text_campos_cadastro}>
                  Palavras-chave
                  <span className={styles.mandatory_carrossel}>*</span>
                </p>
                <div className={styles.auto_complete_area}>
                  <Autocomplete
                    multiple
                    size="small"
                    id="tags-filled"
                    options={allValuesOptions?.palavrasChave?.map(
                      (pc) => pc.palavra
                    )}
                    onChange={(event, newValue) =>
                      updateValue('palavras', newValue)
                    }
                    value={carrossel?.palavras ?? []}
                    freeSolo
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          variant="outlined"
                          label={option}
                          {...getTagProps({ index })}
                          size="small"
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Digite aqui"
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.container_itens}>
                <p className={styles.text_campos_cadastro}>
                  Descrição do Carrossel
                  <span className={styles.mandatory_carrossel}>*</span>
                </p>
                <textarea
                  rows="7"
                  value={carrossel.descricao ?? ''}
                  id="input-descricao"
                  onChange={(evento) => {
                    const newValue = evento.target.value;
                    if (newValue.length < 501)
                      updateValue('descricao', evento.target.value);
                  }}
                  placeholder="Digite aqui a descrição da funcionalidade"
                />
                <div className={styles.sublabel_wrapper}>
                  <p className={styles.sublabel}>
                    {carrossel.descricao?.length ?? 0}/500
                  </p>
                </div>
              </div>

              <div className={styles.container_itens}>
                <div>
                  <div>
                    <p className={styles.text_campos_cadastro}>
                      Perfis
                      <span className={styles.mandatory_carrossel}>*</span>
                    </p>
                    <select
                      value={carrossel?.perfis?.[0]?.id ?? ''}
                      className={styles.height36}
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          allValuesOptions.perfis,
                          event.target.value,
                          true
                        );
                        updateValue('perfis', recovered);
                      }}
                    >
                      <option value={null}>{DEFAULT_VALUE_ALL}</option>
                      {allValuesOptions.perfis.map((pr) => (
                        <option value={pr.id} title={pr.nome}>
                          {formatDefaultValueSelect(pr.nome)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <p className={styles.text_campos_cadastro}>
                      Diagnóstico habilitado
                      <span className={styles.mandatory_carrossel}>*</span>
                    </p>
                    <select
                      value={carrossel.servicosApia?.[0]?.index ?? ''}
                      className={styles.height36}
                      onChange={(event) => {
                        const { value } = event.target;

                        if (value) {
                          const recoveredServico = tipoServico[value];
                          updateValue('servicosApia', [
                            { ...recoveredServico, index: value },
                          ]);
                        } else {
                          updateValue('servicosApia', [value]);
                        }
                      }}
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {tipoServico?.map((pr, index) => (
                        <option value={index} title={pr.titulo}>
                          {pr.titulo}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.div_acoes_carrossel}></div>
            </div>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.container_itens}>
                <div>
                  <p className={styles.text_campos_cadastro}>
                    Tipos<span className={styles.mandatory_carrossel}>*</span>
                  </p>
                  <select
                    value={carrossel.tipo ?? ''}
                    className={styles.height36}
                    onChange={(event) => {
                      setCarrossel({
                        ...carrossel,
                        template: null,
                        tipo: event.target.value,
                      });
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {allValuesOptions.tipos.map((tipo) => (
                      <option value={tipo} title={tipo}>
                        {formatDefaultValueSelect(tipo)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className={styles.container_itens}>
                <div>
                  <p className={styles.text_campos_cadastro}>
                    Quantidade de cards
                    <span className={styles.mandatory_carrossel}>*</span>
                  </p>
                  <input
                    type="number"
                    min="0"
                    value={carrossel.quantidadeCards ?? 0}
                    className={styles.height36}
                    onChange={(event) => {
                      updateValue('quantidadeCards', event.target.value);
                    }}
                  ></input>
                </div>
              </div>
            </div>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.container_itens}>
                <p className={styles.text_campos_cadastro}>
                  Template do carrossel
                  <span className={styles.mandatory_carrossel}>*</span>
                </p>
                <div>
                  {carrossel?.tipo &&
                    carrossel.tipo !== DEFAULT_VALUE_SELECIONE &&
                    allValuesOptions?.templates?.map((tp, index) => {
                      if (
                        carrossel?.tipo === 'CONTEUDO' &&
                        tp === 'CARDS_TOP_10_HORIZONTAIS'
                      ) {
                        return null;
                      }
                      return (
                        <div
                          className={styles.image_container}
                          style={{
                            border:
                              index === carrossel.template
                                ? '3px solid #33CC99'
                                : '1px solid #CDCDCD',
                            marginLeft: index !== 0 ? 20 : 0,
                          }}
                          onClick={() => updateValue('template', index)}
                        >
                          <img
                            src={
                              carrossel?.tipo === 'CONTEUDO'
                                ? templates.conteudo[tp]
                                : templates.cursoseeventos[tp]
                            }
                            alt={`TEMPLATE - ${formatDefaultValueSelect(tp)}`}
                          />
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
            <div className={styles.separator_carrossel}>
              <h3>Abrangência do Carrossel</h3>
            </div>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.container_itens}>
                <div className={styles.local_wrapper}>
                  <div className={styles.uf_style}>
                    <p className={styles.text_campos_cadastro}>UF</p>
                    <select
                      value={carrossel.ufs?.[0]?.id ?? ''}
                      id={styles.uf_style}
                      onChange={(event) =>
                        onChangeUF(allValuesOptions.ufs, event.target.value)
                      }
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.ufs.map((uf) => (
                        <option value={uf.id} title={uf.nome}>
                          {uf.nome}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className={styles.cidade_style}>
                    <p className={styles.text_campos_cadastro}>Cidade</p>
                    <select
                      disabled={isLoadingCidades}
                      id={styles.cidade_style}
                      value={carrossel.cidades?.[0]?.id ?? ''}
                      onChange={(event) => {
                        const recovered = recoveredByid(
                          cidades,
                          event.target.value,
                          true
                        );
                        updateValue('cidades', recovered);
                      }}
                    >
                      {isLoadingCidades ? (
                        <option value={null}>Carregando cidades</option>
                      ) : (
                        <>
                          <option value={null}>
                            {DEFAULT_VALUE_SELECIONE}
                          </option>
                          {cidades.map((cidade) => (
                            <option value={cidade.id} title={cidade.nome}>
                              {cidade.nome}
                            </option>
                          ))}
                        </>
                      )}
                    </select>
                  </div>
                </div>
              </div>
              <div className={styles.container_itens}></div>
            </div>
            <div className={styles.div_acoes_carrossel}>
              <div className={styles.container_itens}>
                <div style={{ flex: '1', flexDirection: 'column' }}>
                  <div>
                    <p className={styles.text_campos_cadastro}>
                      Tipo de usuário
                    </p>
                    <div
                      style={{ display: 'flex', flexDirection: 'row', flex: 1 }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <input
                          type="radio"
                          id="cpf-input"
                          value={isCPF}
                          checked={isCPF}
                          onChange={() => {
                            setIsCPF(true);
                            setCarrossel({
                              ...carrossel,
                              cnpjs: [null],
                              portes: [null],
                              cnaes: [null],
                              segmentos: [null],
                            });
                          }}
                        />
                        <label
                          htmlFor="cpf-input"
                          className={styles.color_label_margin_left5}
                        >
                          CPF
                        </label>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          marginLeft: 10,
                        }}
                      >
                        <input
                          type="radio"
                          id="cnpj-input"
                          value={isCPF}
                          checked={!isCPF}
                          onChange={() => {
                            setIsCPF(false);
                            setCarrossel({
                              ...carrossel,
                              cpfs: [],
                            });
                          }}
                        />
                        <label
                          htmlFor="cnpj-input"
                          className={styles.color_label_margin_left5}
                        >
                          CNPJ
                        </label>

                        {/* Adicionar nome avulso */}
                        <input
                          placeholder={'Insira um CPF'}
                          id={styles.insertCPF}
                          type="text"
                          onChange={(event) => setNewCPF(event.target.value)}
                          // value={newCPF}
                          style={{ marginLeft: '20px' }}
                        />

                        <div style={{ marginLeft: '5px' }}>
                          <BaSeIcon
                            name="plus-circle"
                            size={22}
                            color="#6c6c6c"
                            description="Ícone de adicionar CPF"
                            onClick={() =>
                              setPlanilha([...planilha, newCPF ?? [newCPF]])
                            }
                          />
                        </div>
                        <label for="planilha" style={{ marginLeft: '5px' }}>
                          <BaSeIcon
                            name="document"
                            size={22}
                            color="#6c6c6c"
                            description="Ícone de adicionar lista"
                          />
                        </label>

                        {/* input de planilha escondido */}
                        <input
                          type="file"
                          id="planilha"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          onChange={(event) => updatePlanilha(event)}
                          style={{ display: 'none' }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.container_itens}>
                <div className={styles.cpfs_container}>
                  {planilha &&
                    planilha.length > 0 &&
                    planilha.map((cpf, index) => (
                      <BaSeTag
                        borderColor="transparent"
                        iconBackgroundColor="#db340b"
                        iconColor="#ffffff"
                        label={cpf}
                        labelBackgroundColor="#cfe2fc"
                        labelColor="#005eb8"
                        onClose={() => removeCPF(index)}
                        size="medium"
                      />
                    ))}
                </div>
              </div>
            </div>
            {!isCPF && (
              <div className={styles.div_acoes_carrossel}>
                <div className={styles.container_itens}>
                  <p className={styles.text_campos_cadastro}>Porte</p>
                  <select
                    value={carrossel.portes?.[0]?.id ?? ''}
                    style={{ height: '2.3rem' }}
                    onChange={(event) => {
                      const recovered = recoveredByid(
                        allValuesOptions.portes,
                        event.target.value,
                        true
                      );
                      updateValue('portes', recovered);
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {allValuesOptions.portes.map((pte) => (
                      <option value={pte.id} title={pte.nomePorte}>
                        {pte.nomePorte}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.container_itens}>
                  <p className={styles.text_campos_cadastro}>Segmentos</p>
                  <select
                    value={carrossel.segmentos?.[0]?.id ?? ''}
                    style={{ height: '2.3rem' }}
                    onChange={(event) => {
                      // const value = event.target.value;
                      updateValue('segmentos', parseInt(event.target.value));
                      if (event.target.value !== DEFAULT_VALUE_SELECIONE) {
                        const recovered = recoveredByid(
                          allValuesOptions.segmentos,
                          event.target.value,
                          true
                        );

                        setCnaes(recovered?.[0].cnaes);
                        updateValue('segmentos', recovered);
                      } else {
                        setCnaes([]);
                      }
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {allValuesOptions.segmentos.map((seg) => (
                      <option value={seg.id} title={seg.nome}>
                        {seg.nome}
                      </option>
                    ))}
                  </select>
                </div>

                <div className={styles.container_itens}>
                  <p className={styles.text_campos_cadastro}>Cnae:</p>
                  <select
                    value={carrossel.cnaes?.[0]?.id ?? ''}
                    style={{ height: '2.3rem' }}
                    onChange={(event) => {
                      const recovered = recoveredByid(
                        carrossel.segmentos?.[0].cnaes,
                        event.target.value,
                        true
                      );
                      updateValue('cnaes', recovered);
                    }}
                  >
                    <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                    {cnaes.map((cnae) => (
                      <option value={cnae.id} title={cnae.descricao}>
                        {cnae.descricao}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            )}
            <div
              className={styles.div_acoes_carrossel}
              style={{ marginTop: '10px', marginBottom: '10px' }}
            >
              <div
                className={styles.container_itens}
                style={{ display: 'flex' }}
              >
                <div
                  style={{
                    display: 'flex',
                    flex: '1',
                    justifyContent: 'space-between',
                  }}
                >
                  <div style={{ flex: '1' }}>
                    <p className={styles.text_campos_cadastro}>Usuários que </p>
                    <select
                      value={carrossel.usuariosQue ?? ''}
                      id={styles.userQue}
                      onChange={(event) => {
                        updateValue('usuariosQue', event.target.value);
                      }}
                    >
                      <option value={null}>{DEFAULT_VALUE_SELECIONE}</option>
                      {allValuesOptions.usuariosQue.map((uq) => (
                        <option value={uq} title={uq}>
                          {formatDefaultValueSelect(uq)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={{ flex: '1', alignSelf: 'flex-end' }}>
                    <BaSeButton
                      color="#33CC99"
                      value={
                        isLoading
                          ? 'Enviando ...'
                          : typeScreen === 3
                          ? 'Editar Funcionalidade'
                          : 'Incluir Funcionalidade'
                      }
                      onClick={adicionarCarrossel}
                      isDisabled={isLoading ? true : false}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.updatedAt_carrossel_container}>
              {carrossel.atualizadoPor && typeScreen === 3 && (
                <h5>
                  Atualizado em {formatDateToBR(carrossel.ultimaAtualizacao)}{' '}
                  por {carrossel?.atualizadoPor?.nome}
                </h5>
              )}
              {carrossel.criadoPor && typeScreen === 3 && (
                <h5>
                  Criado em {formatDateToBR(carrossel.dataCriacao)} por{' '}
                  {carrossel?.criadoPor?.nome}
                </h5>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
